// src/table/AppProductoReactTable.jsx
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { useSortBy, usePagination } from "react-table";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Modal, Button, Table as BsTable, Spinner } from "react-bootstrap";

import Table from "./TableContainer";
import ModalProducto from "../components/ModalProducto";
import "../css/tablecomandas.css";

import ridersLogo from "../images/ridersmiami-logo.png";

import {
  getProductos,
  getProductoById,
  deleteProducto,
} from "../helpers/rutaProductos";

import { puedeVerCostosFront } from "../helpers/permisosCostos";

import { getCategoriasProductos } from "../helpers/rutaCategoriasProductos";
import { getMarcas } from "../helpers/rutaMarcas";
import { getColores } from "../helpers/rutaColores";

const Styles = styled.div`
  .table-container {
    width: 100%;
    max-height: calc(100vh - 250px);
    overflow: auto;
    border: 1px solid var(--app-border, #d9dee7);
    border-radius: 10px;
    background: var(--app-card, #fff);
  }

  .table-container table {
    width: max-content !important;
    min-width: 1760px;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    margin-bottom: 0 !important;
  }

  .table-container thead th {
    position: sticky;
    top: 0;
    z-index: 4;
    background: linear-gradient(180deg, #2f6fe4 0%, #214fae 100%) !important;
    color: #fff !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    line-height: 1.15 !important;
    text-align: center !important;
    vertical-align: middle !important;
    padding: 7px 6px !important;
    border: 1px solid #1c469e !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .table-container thead tr:nth-child(2) {
    display: none !important;
  }

  .table-container tbody td {
    height: 40px;
    padding: 6px 8px !important;
    border: 1px solid var(--app-border-soft, #dde2e8) !important;
    vertical-align: middle !important;
    font-size: 13px !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    background: var(--app-table-row, #fff) !important;
    color: var(--app-text, #111827) !important;
  }

  .table-container tbody tr:nth-child(odd) td {
    background: var(--app-table-row-alt, #f8fafc) !important;
  }

  .table-container tbody tr:hover td {
    background: rgba(47, 128, 255, 0.12) !important;
  }

  html[data-theme="dark"] & .card,
  html[data-theme="dark"] & .card-body {
    background: var(--app-card, #0f1b2d) !important;
    color: var(--app-text, #f8fafc) !important;
  }

  html[data-theme="dark"] & .table-container {
    border-color: #2a3f60;
    background: #0f1b2d;
  }

  html[data-theme="dark"] & .table-container tbody td {
    background: #0f1b2d !important;
    color: #f8fafc !important;
    border-color: #2a3f60 !important;
  }

  html[data-theme="dark"] & .table-container tbody tr:nth-child(odd) td {
    background: #10213a !important;
  }

  html[data-theme="dark"] & .table-container tbody tr:nth-child(even) td {
    background: #0d1b31 !important;
  }

  html[data-theme="dark"] & .table-container tbody tr:hover td {
    background: #18345a !important;
  }

  .table-container th:nth-child(1),
  .table-container td:nth-child(1) {
    width: 50px !important;
    min-width: 50px !important;
    max-width: 50px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(2),
  .table-container td:nth-child(2) {
    width: 55px !important;
    min-width: 55px !important;
    max-width: 55px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(3),
  .table-container td:nth-child(3) {
    width: 55px !important;
    min-width: 55px !important;
    max-width: 55px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(4),
  .table-container td:nth-child(4) {
    width: 55px !important;
    min-width: 55px !important;
    max-width: 55px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(5),
  .table-container td:nth-child(5) {
    width: 75px !important;
    min-width: 75px !important;
    max-width: 75px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(6),
  .table-container td:nth-child(6) {
    width: 230px !important;
    min-width: 230px !important;
    max-width: 230px !important;
    text-align: left !important;
  }

  .table-container th:nth-child(7),
  .table-container td:nth-child(7) {
    width: 160px !important;
    min-width: 160px !important;
    max-width: 160px !important;
    text-align: left !important;
  }

  .table-container th:nth-child(8),
  .table-container td:nth-child(8) {
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    text-align: left !important;
  }

  .table-container th:nth-child(9),
  .table-container td:nth-child(9) {
    width: 140px !important;
    min-width: 140px !important;
    max-width: 140px !important;
    text-align: left !important;
  }

  .table-container th:nth-child(10),
  .table-container td:nth-child(10) {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(11),
  .table-container td:nth-child(11),
  .table-container th:nth-child(12),
  .table-container td:nth-child(12),
  .table-container th:nth-child(13),
  .table-container td:nth-child(13) {
    width: 95px !important;
    min-width: 95px !important;
    max-width: 95px !important;
    text-align: right !important;
  }

  .table-container th:nth-child(14),
  .table-container td:nth-child(14) {
    width: 180px !important;
    min-width: 180px !important;
    max-width: 180px !important;
    text-align: left !important;
  }

  .table-container th:nth-child(15),
  .table-container td:nth-child(15),
  .table-container th:nth-child(16),
  .table-container td:nth-child(16),
  .table-container th:nth-child(17),
  .table-container td:nth-child(17),
  .table-container th:nth-child(18),
  .table-container td:nth-child(18) {
    width: 125px !important;
    min-width: 125px !important;
    max-width: 125px !important;
    text-align: right !important;
  }

  .table-container th:nth-child(19),
  .table-container td:nth-child(19) {
    width: 70px !important;
    min-width: 70px !important;
    max-width: 70px !important;
    text-align: center !important;
  }

  .table-container th:nth-child(20),
  .table-container td:nth-child(20) {
    width: 125px !important;
    min-width: 125px !important;
    max-width: 125px !important;
    text-align: right !important;
  }

  .action-btn {
    width: 28px !important;
    height: 28px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 5px !important;
    font-size: 13px !important;
    line-height: 1 !important;
    margin: 0 auto !important;
    border: none !important;
  }

  .action-btn i {
    line-height: 1 !important;
  }

  .action-btn--edit {
    background: #1565c0 !important;
    color: #fff !important;
  }

  .action-btn--del {
    background: #c62828 !important;
    color: #fff !important;
  }
`;

/* ---------------- helpers generales ---------------- */

const clean = (v) => String(v ?? "").trim();

function norm(v) {
  return clean(v)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

const digits = (v) => String(v ?? "").replace(/\D/g, "");

const textOrDash = (v) => {
  const s = clean(v);
  return s || "-";
};

const sanitizeFileName = (v) =>
  clean(v)
    .replace(/[\\/:*?"<>|]+/g, "")
    .replace(/\s+/g, "_");

const formatUSD = (v) => {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "US$ 0.00";

  return n.toLocaleString("es-AR", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
};

const fmtNumber = (v) => {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "0";

  return n.toLocaleString("es-AR", {
    maximumFractionDigits: 2,
  });
};

const fmtDate = (v) => {
  if (!v) return "-";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("es-AR");
};

const getId = (v) => {
  if (!v) return "";
  if (typeof v === "object") return clean(v._id ?? v.id ?? v.value ?? "");
  return clean(v);
};

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

const fitImageInBox = (img, maxW, maxH) => {
  const w = img?.naturalWidth || img?.width || maxW;
  const h = img?.naturalHeight || img?.height || maxH;
  const ratio = Math.min(maxW / w, maxH / h);

  return {
    w: w * ratio,
    h: h * ratio,
  };
};

function uniqById(arr) {
  const map = new Map();

  for (const it of arr || []) {
    const key = it?._id ?? it?.codprod ?? JSON.stringify(it);
    if (!map.has(key)) map.set(key, it);
  }

  return Array.from(map.values());
}

function useDebounce(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}

/* ---------------- unwraps ---------------- */

const unwrapProductos = (r) => {
  if (Array.isArray(r?.productos)) return r.productos;
  if (Array.isArray(r?.data?.productos)) return r.data.productos;
  if (Array.isArray(r?.data)) return r.data;
  if (Array.isArray(r)) return r;
  return [];
};

const unwrapCategorias = (r) => {
  if (Array.isArray(r?.categorias)) return r.categorias;
  if (Array.isArray(r?.categoriasProductos)) return r.categoriasProductos;
  if (Array.isArray(r?.data?.categorias)) return r.data.categorias;
  if (Array.isArray(r?.data?.categoriasProductos)) return r.data.categoriasProductos;
  if (Array.isArray(r?.data)) return r.data;
  if (Array.isArray(r)) return r;
  return [];
};

const unwrapMarcas = (r) => {
  if (Array.isArray(r?.marcas)) return r.marcas;
  if (Array.isArray(r?.data?.marcas)) return r.data.marcas;
  if (Array.isArray(r?.data)) return r.data;
  if (Array.isArray(r)) return r;
  return [];
};

const unwrapColores = (r) => {
  if (Array.isArray(r?.colores)) return r.colores;
  if (Array.isArray(r?.data?.colores)) return r.data.colores;
  if (Array.isArray(r?.data)) return r.data;
  if (Array.isArray(r)) return r;
  return [];
};

const getProductoFromResponse = (resp, fallback = null) => {
  if (resp?.producto) return resp.producto;
  if (resp?.data?.producto) return resp.data.producto;
  if (resp?.data) return resp.data;
  return resp || fallback;
};

/* ---------------- nombres catálogos ---------------- */

const getCategoriaNombre = (c) =>
  clean(c?.nombre) ||
  clean(c?.categoria) ||
  clean(c?.descripcion) ||
  clean(c?.label) ||
  "-";

const getCategoriaCodigo = (c) =>
  clean(c?.codigo) ||
  clean(c?.codcategoria) ||
  clean(c?.codcat) ||
  clean(c?.cod) ||
  "";

const getMarcaNombre = (m) =>
  clean(m?.marca) ||
  clean(m?.nombre) ||
  clean(m?.descripcion) ||
  clean(m?.label) ||
  "-";

const getMarcaCodigo = (m) =>
  clean(m?.codmarca) ||
  clean(m?.codigo) ||
  clean(m?.cod) ||
  "";

const getColorNombre = (c) =>
  clean(c?.color) ||
  clean(c?.nombre) ||
  clean(c?.descripcion) ||
  clean(c?.label) ||
  "-";

const getColorCodigo = (c) =>
  clean(c?.codcolor) ||
  clean(c?.codigo) ||
  clean(c?.cod) ||
  "";

const btnActionSmall = {
  width: 28,
  height: 28,
  padding: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 4,
  fontSize: 13,
};

export default function AppProductoReactTable() {
  const puedeVerCostos = puedeVerCostosFront();
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  const [categorias, setCategorias] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [colores, setColores] = useState([]);

  const [showEdit, setShowEdit] = useState(false);
  const [productoEdit, setProductoEdit] = useState(null);

  const [showFicha, setShowFicha] = useState(false);
  const [fichaData, setFichaData] = useState(null);
  const [fichaLoadingId, setFichaLoadingId] = useState(null);
  const [pdfLoadingId, setPdfLoadingId] = useState(null);

  const [q, setQ] = useState("");
  const dq = useDebounce(q, 250);

  const [progress, setProgress] = useState({
    loaded: 0,
    total: 0,
  });

  const seqRef = useRef(0);
  const abortRef = useRef(null);

  const categoriasMap = useMemo(() => {
    const map = {};

    categorias.forEach((c) => {
      const id = getId(c);
      const codigo = getCategoriaCodigo(c);
      const nombre = getCategoriaNombre(c);

      if (id) map[id] = nombre;
      if (codigo) map[String(codigo)] = nombre;
    });

    return map;
  }, [categorias]);

  const marcasMap = useMemo(() => {
    const map = {};

    marcas.forEach((m) => {
      const id = getId(m);
      const codigo = getMarcaCodigo(m);
      const nombre = getMarcaNombre(m);

      if (id) map[id] = nombre;
      if (codigo) map[String(codigo)] = nombre;
    });

    return map;
  }, [marcas]);

  const coloresMap = useMemo(() => {
    const map = {};

    colores.forEach((c) => {
      const id = getId(c);
      const codigo = getColorCodigo(c);
      const nombre = getColorNombre(c);

      if (id) map[id] = nombre;
      if (codigo) map[String(codigo)] = nombre;
    });

    return map;
  }, [colores]);

  const productoNombre = useCallback((p = {}) => {
    return (
      clean(p?.nombreComercial) ||
      clean(p?.descripcion) ||
      clean(p?.modelo) ||
      "-"
    );
  }, []);

  const categoriaTxt = useCallback(
    (p = {}) => {
      const cat = p?.categoria;

      if (typeof cat === "object") {
        const nombre = getCategoriaNombre(cat);
        if (nombre !== "-") return nombre;
      }

      const id = getId(cat);
      return categoriasMap[id] || "-";
    },
    [categoriasMap]
  );

  const marcaTxt = useCallback(
    (p = {}) => {
      const marca = p?.marca;

      if (typeof marca === "object") {
        const nombre = getMarcaNombre(marca);
        if (nombre !== "-") return nombre;
      }

      const id = getId(marca);
      return marcasMap[id] || "-";
    },
    [marcasMap]
  );

  const coloresTxt = useCallback(
    (p = {}) => {
      if (!p?.usaColor) return "NO APLICA";

      const arr = Array.isArray(p?.coloresDisponibles)
        ? p.coloresDisponibles
        : [];

      if (!arr.length) return "-";

      return arr
        .map((c) => {
          if (typeof c === "object") {
            const nombre = getColorNombre(c);
            if (nombre !== "-") return nombre;
          }

          const id = getId(c);
          return coloresMap[id] || id || "-";
        })
        .filter(Boolean)
        .join(", ");
    },
    [coloresMap]
  );

  const enriquecerProducto = useCallback(
    (p = {}) => ({
      ...p,
      _productoTxt: productoNombre(p),
      _categoriaTxt: categoriaTxt(p),
      _marcaTxt: marcaTxt(p),
      _coloresTxt: coloresTxt(p),
    }),
    [productoNombre, categoriaTxt, marcaTxt, coloresTxt]
  );

  const cargarCatalogos = useCallback(async () => {
    try {
      const [catsResp, marcasResp, coloresResp] = await Promise.all([
        getCategoriasProductos({ limit: 10000 }),
        getMarcas({ limit: 10000 }),
        getColores({ limit: 10000 }),
      ]);

      setCategorias(unwrapCategorias(catsResp));
      setMarcas(unwrapMarcas(marcasResp));
      setColores(unwrapColores(coloresResp));
    } catch (e) {
      console.error("❌ Error cargando catálogos de productos:", e);
      setCategorias([]);
      setMarcas([]);
      setColores([]);
    }
  }, []);

  const fetchAll = useCallback(async () => {
    try {
      abortRef.current?.abort?.();
    } catch (_) {}

    const controller = new AbortController();
    abortRef.current = controller;

    const seq = ++seqRef.current;

    setLoading(true);
    setAll([]);
    setProgress({ loaded: 0, total: 0 });

    const LIMIT = 200;

    try {
      await cargarCatalogos();

      const first = await getProductos({
        page: 1,
        limit: LIMIT,
        q: "",
        signal: controller.signal,
      });

      if (seq !== seqRef.current) return;

      const total = Number(first?.total || 0);
      let acc = unwrapProductos(first);

      acc = uniqById(acc);

      setAll(acc);
      setProgress({
        loaded: acc.length,
        total,
      });

      const pages = Math.max(1, Math.ceil(total / LIMIT));

      for (let p = 2; p <= pages; p++) {
        const r = await getProductos({
          page: p,
          limit: LIMIT,
          q: "",
          signal: controller.signal,
        });

        if (seq !== seqRef.current) return;

        acc = uniqById(acc.concat(unwrapProductos(r)));

        setAll(acc);
        setProgress({
          loaded: acc.length,
          total,
        });
      }
    } catch (e) {
      if (e?.name === "CanceledError" || e?.code === "ERR_CANCELED") return;

      console.error("❌ Error cargando productos:", e);

      setAll([]);
      setProgress({
        loaded: 0,
        total: 0,
      });
    } finally {
      if (seq === seqRef.current) {
        setLoading(false);
      }
    }
  }, [cargarCatalogos]);

  useEffect(() => {
    fetchAll();

    return () => {
      try {
        abortRef.current?.abort?.();
      } catch (_) {}
    };
  }, [fetchAll]);

  const borrar = useCallback(async (mongoId) => {
    if (!mongoId) {
      alert("No se encontró el ID del producto.");
      return;
    }

    if (!window.confirm("¿Eliminar producto?")) return;

    try {
      await deleteProducto(mongoId);
      setAll((prev) => prev.filter((p) => p?._id !== mongoId));
    } catch (e) {
      console.error("❌ Error deleteProducto:", e);
      alert("No se pudo borrar el producto.");
    }
  }, []);

  const abrirEdicion = useCallback((producto) => {
    setProductoEdit(producto);
    setShowEdit(true);
  }, []);

  const cerrarEdicion = useCallback(() => {
    setShowEdit(false);
    setProductoEdit(null);
    fetchAll();
  }, [fetchAll]);

  const cargarFichaData = useCallback(
    async (productoRow) => {
      const safe = async (label, fn, fallback) => {
        try {
          return await fn();
        } catch (e) {
          console.error(`❌ Error cargando ${label}:`, e);
          return fallback;
        }
      };

      const productoResp = await safe(
        "producto por ID",
        () => getProductoById(productoRow._id),
        productoRow
      );

      const producto = getProductoFromResponse(productoResp, productoRow);

      return {
        producto: enriquecerProducto(producto),
        fechaEmision: new Date(),
      };
    },
    [enriquecerProducto]
  );

  const abrirFichaProducto = useCallback(
    async (productoRow) => {
      if (!productoRow?._id) {
        alert("No se encontró el ID del producto.");
        return;
      }

      try {
        setFichaLoadingId(productoRow._id);
        setFichaData(null);
        setShowFicha(true);

        const data = await cargarFichaData(productoRow);
        setFichaData(data);
      } catch (e) {
        console.error("❌ Error abriendo ficha del producto:", e);

        setFichaData({
          producto: enriquecerProducto(productoRow),
          fechaEmision: new Date(),
        });
      } finally {
        setFichaLoadingId(null);
      }
    },
    [cargarFichaData, enriquecerProducto]
  );

  const generarPdfFicha = useCallback(
    async (productoRow) => {
      if (!productoRow?._id) return;

      try {
        setPdfLoadingId(productoRow._id);

        const data = await cargarFichaData(productoRow);
        const { producto, fechaEmision } = data;

        const doc = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();

        try {
          const logo = await loadImage(ridersLogo);
          const box = fitImageInBox(logo, 38, 22);
          doc.addImage(logo, "PNG", 10, 7, box.w, box.h);
        } catch (e) {
          console.warn("No se pudo cargar el logo para el PDF:", e);
        }

        doc.setFont("times", "bold");
        doc.setFontSize(20);
        doc.text("FICHA DEL PRODUCTO", pageWidth / 2, 16, {
          align: "center",
        });

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`N°: ${textOrDash(producto?.codprod)}`, 190, 16, {
          align: "right",
        });

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(`Fecha emisión: ${fmtDate(fechaEmision)}`, 190, 22, {
          align: "right",
        });

        doc.setDrawColor(60);
        doc.setLineWidth(0.3);
        doc.line(10, 30, 200, 30);

        autoTable(doc, {
          startY: 34,
          theme: "grid",
          styles: {
            fontSize: 8.5,
            cellPadding: 2,
            valign: "middle",
            overflow: "linebreak",
          },
          columnStyles: {
            0: { cellWidth: 35, fontStyle: "bold" },
            1: { cellWidth: 60 },
            2: { cellWidth: 35, fontStyle: "bold" },
            3: { cellWidth: 60 },
          },
          body: [
            [
              "Código",
              textOrDash(producto?.codprod),
              "Activo",
              producto?.activo ? "Sí" : "No",
            ],
            [
              "Producto",
              textOrDash(producto?._productoTxt),
              "Modelo",
              textOrDash(producto?.modelo),
            ],
            [
              "Categoría",
              textOrDash(producto?._categoriaTxt),
              "Marca",
              textOrDash(producto?._marcaTxt),
            ],
            [
              "Tipo Motor",
              textOrDash(producto?.tipoMotor),
              "Colores",
              textOrDash(producto?._coloresTxt),
            ],
            [
              "Cilindrada CC",
              fmtNumber(producto?.cilindradaCC),
              "Potencia Watts",
              fmtNumber(producto?.potenciaWatts),
            ],
            [
              "Potencia Kw",
              fmtNumber(producto?.potenciaKw),
              "Tensión Volt",
              fmtNumber(producto?.tensionVolt),
            ],
            [
              "Capacidad Ah",
              fmtNumber(producto?.capacidadAh),
              "Capacidad Kwh",
              fmtNumber(producto?.capacidadKwh),
            ],
            [
              "Cant. Paneles",
              fmtNumber(producto?.cantidadPaneles),
              "Pot. Panel Watts",
              fmtNumber(producto?.potenciaPanelWatts),
            ],
            [
              "Precio Venta USD",
              formatUSD(producto?.precioVentaUSD),
              "Precio Mínimo USD",
              formatUSD(producto?.precioMinimoUSD),
            ],
            [
              "Comisión Base USD",
              formatUSD(producto?.comisionBaseUSD),
              "Costo Envío USD",
              formatUSD(producto?.costoEnvioUSD),
            ],
            [
              "Política Envío",
              textOrDash(producto?.politicaEnvio),
              "Permite Envío",
              producto?.permiteEnvio ? "Sí" : "No",
            ],
            [
              "Demora Entrega",
              textOrDash(producto?.demoraEntrega),
              "Aclaración",
              textOrDash(producto?.aclaracion),
            ],
            [
              "Descripción",
              textOrDash(producto?.descripcion),
              "Observaciones",
              textOrDash(producto?.observaciones),
            ],
          ],
        });

        if (Array.isArray(producto?.especificaciones) && producto.especificaciones.length) {
          autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 6,
            theme: "grid",
            head: [["Especificación", "Valor"]],
            body: producto.especificaciones.map((e) => [
              textOrDash(e?.nombre),
              textOrDash(e?.valor),
            ]),
            styles: {
              fontSize: 8.5,
              cellPadding: 2,
            },
            headStyles: {
              fillColor: [47, 111, 228],
            },
          });
        }

        doc.save(
          `Ficha_Producto_${textOrDash(producto?.codprod)}_${sanitizeFileName(
            producto?._productoTxt
          )}.pdf`
        );
      } catch (e) {
        console.error("❌ Error generando PDF de producto:", e);
        alert("No se pudo generar el PDF de la ficha del producto.");
      } finally {
        setPdfLoadingId(null);
      }
    },
    [cargarFichaData]
  );

  const allEnriquecidos = useMemo(
    () => (all || []).map((p) => enriquecerProducto(p)),
    [all, enriquecerProducto]
  );

  const dataFiltrada = useMemo(() => {
    const raw = clean(dq);

    if (!raw) return allEnriquecidos;

    const hasLetters = /[a-zA-ZáéíóúñüÁÉÍÓÚÑÜ]/.test(raw);
    const qText = norm(raw);
    const qNum = digits(raw);

    return (allEnriquecidos || []).filter((p) => {
      const cod = digits(p?.codprod);

      const producto = norm(p?._productoTxt);
      const modelo = norm(p?.modelo);
      const descripcion = norm(p?.descripcion);
      const categoria = norm(p?._categoriaTxt);
      const marca = norm(p?._marcaTxt);
      const motor = norm(p?.tipoMotor);
      const coloresTexto = norm(p?._coloresTxt);

      if (hasLetters) {
        return (
          producto.includes(qText) ||
          modelo.includes(qText) ||
          descripcion.includes(qText) ||
          categoria.includes(qText) ||
          marca.includes(qText) ||
          motor.includes(qText) ||
          coloresTexto.includes(qText)
        );
      }

      if (!qNum) return false;

      return cod.startsWith(qNum);
    });
  }, [allEnriquecidos, dq]);

  const exportRows = useCallback((rows) => {
    return (rows || []).map((p) => ({
      Código: p?.codprod || "",
      Producto: p?._productoTxt || "",
      Modelo: p?.modelo || "",
      Categoría: p?._categoriaTxt || "",
      Marca: p?._marcaTxt || "",
      Motor: p?.tipoMotor || "",
      "Cilindrada CC": p?.cilindradaCC || 0,
      "Potencia Watts": p?.potenciaWatts || 0,
      "Potencia Kw": p?.potenciaKw || 0,
      Colores: p?._coloresTxt || "",
      "Precio Venta USD": p?.precioVentaUSD || 0,
      "Precio Mínimo USD": p?.precioMinimoUSD || 0,
      "Comisión USD": p?.comisionBaseUSD || 0,
      "Costo Envío USD": p?.costoEnvioUSD || 0,
      Activo: p?.activo ? "Sí" : "No",
    }));
  }, []);

  const descargarCsv = useCallback((rows, filename) => {
    const data = exportRows(rows);

    if (!data.length) {
      alert("No hay datos para exportar.");
      return;
    }

    const headers = Object.keys(data[0]);

    const escapeCsv = (v) => {
      const s = String(v ?? "");
      return `"${s.replace(/"/g, '""')}"`;
    };

    const csv = [
      headers.map(escapeCsv).join(";"),
      ...data.map((row) => headers.map((h) => escapeCsv(row[h])).join(";")),
    ].join("\r\n");

    const blob = new Blob(["\ufeff" + csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(url);
  }, [exportRows]);

  const exportarPdfListado = useCallback((rows, filename, titulo) => {
    if (!rows.length) {
      alert("No hay datos para exportar.");
      return;
    }

    const doc = new jsPDF({
      orientation: "l",
      unit: "mm",
      format: "a4",
    });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.text(titulo, 148, 14, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Fecha: ${fmtDate(new Date())}`, 285, 14, { align: "right" });

    autoTable(doc, {
      startY: 20,
      theme: "grid",
      styles: {
        fontSize: 7.5,
        cellPadding: 1.8,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [47, 111, 228],
      },
      head: [[
        "Código",
        "Producto",
        "Modelo",
        "Categoría",
        "Marca",
        "Motor",
        "Colores",
        "Venta USD",
        "Mínimo USD",
        "Activo",
      ]],
      body: rows.map((p) => [
        textOrDash(p?.codprod),
        textOrDash(p?._productoTxt),
        textOrDash(p?.modelo),
        textOrDash(p?._categoriaTxt),
        textOrDash(p?._marcaTxt),
        textOrDash(p?.tipoMotor),
        textOrDash(p?._coloresTxt),
        formatUSD(p?.precioVentaUSD),
        formatUSD(p?.precioMinimoUSD),
        p?.activo ? "Sí" : "No",
      ]),
      columnStyles: {
        0: { cellWidth: 18, halign: "center" },
        1: { cellWidth: 45 },
        2: { cellWidth: 35 },
        3: { cellWidth: 32 },
        4: { cellWidth: 32 },
        5: { cellWidth: 25 },
        6: { cellWidth: 35 },
        7: { cellWidth: 25, halign: "right" },
        8: { cellWidth: 25, halign: "right" },
        9: { cellWidth: 15, halign: "center" },
      },
    });

    doc.save(filename);
  }, []);

  const columns = useMemo(
    () => [
      {
        id: "editar",
        Header: "Edita",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--edit"
            title="Editar"
            onClick={() => abrirEdicion(row.original)}
          >
            <i className="fa fa-pencil" aria-hidden="true" />
          </button>
        ),
      },
      {
        id: "verFicha",
        Header: "Ver",
        accessor: "_id",
        width: 55,
        Cell: ({ row }) => (
          <button
            className="action-btn"
            title="Ver ficha del producto"
            onClick={() => abrirFichaProducto(row.original)}
            disabled={fichaLoadingId === row.original._id}
            style={{
              ...btnActionSmall,
              backgroundColor: "#1565c0",
              color: "#fff",
              cursor:
                fichaLoadingId === row.original._id ? "not-allowed" : "pointer",
              opacity: fichaLoadingId === row.original._id ? 0.7 : 1,
            }}
          >
            <i className="fa fa-eye" aria-hidden="true" />
          </button>
        ),
      },
      {
        id: "pdf",
        Header: "PDF",
        accessor: "_id",
        width: 55,
        Cell: ({ row }) => (
          <button
            className="action-btn"
            title="PDF ficha producto"
            onClick={() => generarPdfFicha(row.original)}
            disabled={pdfLoadingId === row.original._id}
            style={{
              ...btnActionSmall,
              backgroundColor: "#b71c1c",
              color: "#fff",
              cursor:
                pdfLoadingId === row.original._id ? "not-allowed" : "pointer",
              opacity: pdfLoadingId === row.original._id ? 0.7 : 1,
            }}
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true" />
          </button>
        ),
      },
      {
        id: "eliminar",
        Header: "Borrar",
        accessor: "_id",
        width: 55,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--del"
            title="Eliminar"
            onClick={() => borrar(row.original._id)}
          >
            <i className="fa fa-trash-o" aria-hidden="true" />
          </button>
        ),
      },
      {
        Header: "Código",
        accessor: "codprod",
        width: 75,
      },
      {
        Header: "Producto",
        accessor: "_productoTxt",
        width: 230,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Modelo",
        accessor: "modelo",
        width: 160,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Categoría",
        accessor: "_categoriaTxt",
        width: 150,
      },
      {
        Header: "Marca",
        accessor: "_marcaTxt",
        width: 140,
      },
      {
        Header: "Motor",
        accessor: "tipoMotor",
        width: 120,
      },
      {
        Header: "Cil. CC",
        accessor: "cilindradaCC",
        width: 95,
        Cell: ({ value }) => fmtNumber(value),
      },
      {
        Header: "Watts",
        accessor: "potenciaWatts",
        width: 95,
        Cell: ({ value }) => fmtNumber(value),
      },
      {
        Header: "Kw",
        accessor: "potenciaKw",
        width: 95,
        Cell: ({ value }) => fmtNumber(value),
      },
      {
        Header: "Colores",
        accessor: "_coloresTxt",
        width: 180,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Precio Venta USD",
        accessor: "precioVentaUSD",
        width: 125,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Precio Mínimo USD",
        accessor: "precioMinimoUSD",
        width: 125,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Comisión USD",
        accessor: "comisionBaseUSD",
        width: 125,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Envío USD",
        accessor: "costoEnvioUSD",
        width: 125,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Activo",
        accessor: "activo",
        width: 70,
        Cell: ({ value }) => (value ? "Sí" : "No"),
      },
      ...(puedeVerCostos
        ? [
            {
              Header: "Costo Producto USD",
              accessor: "costoProductoUSD",
              width: 125,
              Cell: ({ value }) => formatUSD(value),
            },
          ]
        : []),
    ],
    [
      abrirEdicion,
      abrirFichaProducto,
      borrar,
      fichaLoadingId,
      generarPdfFicha,
      pdfLoadingId,
      puedeVerCostos,
    ]
  );

  const tableKey = useMemo(
    () => `${loading ? "loading" : "ready"}-${dataFiltrada.length}-${q}`,
    [loading, dataFiltrada.length, q]
  );

  return (
    <>
      <div className="container-xl mt-4">
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <h3 className="text-center mb-3">LISTADO DE PRODUCTOS</h3>

            <div className="mb-3">
              <div className="d-flex align-items-end justify-content-between gap-3 flex-wrap">
                <div className="d-flex align-items-end gap-3 flex-wrap">
                  <div style={{ minWidth: 360 }}>
                    <label className="form-label mb-0 small">Buscar</label>
                    <input
                      className="form-control form-control-sm"
                      placeholder="producto / modelo / categoría / marca / motor / código"
                      value={q}
                      onChange={(e) => setQ(e.target.value)}
                    />
                  </div>

                  <div
                    className="small text-muted mb-1"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {loading
                      ? `Cargando ${progress.loaded} / ${
                          progress.total || "?"
                        }...`
                      : `Mostrando ${dataFiltrada.length} de ${all.length}`}
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button
                    className="btn btn-outline-secondary btn-sm px-3"
                    style={{ fontSize: 14 }}
                    onClick={() => setQ("")}
                  >
                    Limpiar
                  </button>

                  <button
                    className="btn btn-outline-primary btn-sm px-3"
                    style={{ fontSize: 14 }}
                    onClick={fetchAll}
                    disabled={loading}
                  >
                    Recargar
                  </button>
                </div>
              </div>
            </div>

            {/* <div className="row g-2 mb-3">
              <div className="col-md-3">
                <button
                  className="btn btn-primary btn-sm w-100"
                  onClick={() =>
                    descargarCsv(allEnriquecidos, "productos_todo.csv")
                  }
                  disabled={loading}
                >
                  Exportar TODO Excel
                </button>
              </div>

              <div className="col-md-3">
                <button
                  className="btn btn-info btn-sm w-100"
                  onClick={() =>
                    descargarCsv(dataFiltrada, "productos_vista.csv")
                  }
                  disabled={loading}
                >
                  Exportar Vista Excel
                </button>
              </div>

              <div className="col-md-3">
                <button
                  className="btn btn-success btn-sm w-100"
                  onClick={() =>
                    exportarPdfListado(
                      allEnriquecidos,
                      "productos_todo.pdf",
                      "LISTADO DE PRODUCTOS"
                    )
                  }
                  disabled={loading}
                >
                  Exportar TODO PDF
                </button>
              </div>

              <div className="col-md-3">
                <button
                  className="btn btn-warning btn-sm w-100"
                  onClick={() =>
                    exportarPdfListado(
                      dataFiltrada,
                      "productos_vista.pdf",
                      "LISTADO DE PRODUCTOS - VISTA"
                    )
                  }
                  disabled={loading}
                >
                  Exportar Vista PDF 1
                </button>
              </div>
            </div> */}

            <Styles>
              <div className="table-container">
                <Table
                  key={tableKey}
                  columns={columns}
                  data={dataFiltrada}
                  loading={loading}
                  plugins={[useSortBy, usePagination]}
                />
              </div>
            </Styles>
          </div>
        </div>
      </div>

      <ModalProducto
        show={showEdit}
        producto={productoEdit}
        handleClose={cerrarEdicion}
      />

      <Modal
        show={showFicha}
        onHide={() => setShowFicha(false)}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Ficha del Producto</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {fichaLoadingId && !fichaData ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
              <div className="mt-2">Cargando ficha...</div>
            </div>
          ) : fichaData?.producto ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #333",
                  paddingBottom: 12,
                  marginBottom: 16,
                }}
              >
                <div style={{ width: 160 }}>
                  <img
                    src={ridersLogo}
                    alt="Logo"
                    style={{
                      maxWidth: 130,
                      maxHeight: 55,
                      objectFit: "contain",
                    }}
                  />
                </div>

                <div
                  style={{
                    flex: 1,
                    textAlign: "center",
                    fontFamily: "serif",
                    fontWeight: "bold",
                    fontSize: 28,
                  }}
                >
                  FICHA DEL PRODUCTO
                </div>

                <div style={{ width: 170, textAlign: "right" }}>
                  <div style={{ fontWeight: "bold", fontSize: 18 }}>
                    N°: {textOrDash(fichaData.producto?.codprod)}
                  </div>

                  <div style={{ fontSize: 13, marginTop: 8 }}>
                    Fecha emisión: {fmtDate(fichaData.fechaEmision)}
                  </div>
                </div>
              </div>

              <BsTable bordered size="sm" responsive style={{ fontSize: 13 }}>
                <tbody>
                  <tr>
                    <th style={{ width: "15%" }}>Código</th>
                    <td style={{ width: "35%" }}>
                      {textOrDash(fichaData.producto?.codprod)}
                    </td>

                    <th style={{ width: "15%" }}>Activo</th>
                    <td style={{ width: "35%" }}>
                      {fichaData.producto?.activo ? "Sí" : "No"}
                    </td>
                  </tr>

                  <tr>
                    <th>Producto</th>
                    <td>{textOrDash(fichaData.producto?._productoTxt)}</td>

                    <th>Modelo</th>
                    <td>{textOrDash(fichaData.producto?.modelo)}</td>
                  </tr>

                  <tr>
                    <th>Categoría</th>
                    <td>{textOrDash(fichaData.producto?._categoriaTxt)}</td>

                    <th>Marca</th>
                    <td>{textOrDash(fichaData.producto?._marcaTxt)}</td>
                  </tr>

                  <tr>
                    <th>Descripción</th>
                    <td colSpan={3}>
                      {textOrDash(fichaData.producto?.descripcion)}
                    </td>
                  </tr>

                  <tr>
                    <th>Tipo Motor</th>
                    <td>{textOrDash(fichaData.producto?.tipoMotor)}</td>

                    <th>Colores</th>
                    <td>{textOrDash(fichaData.producto?._coloresTxt)}</td>
                  </tr>

                  <tr>
                    <th>Cilindrada CC</th>
                    <td>{fmtNumber(fichaData.producto?.cilindradaCC)}</td>

                    <th>Potencia Watts</th>
                    <td>{fmtNumber(fichaData.producto?.potenciaWatts)}</td>
                  </tr>

                  <tr>
                    <th>Potencia Kw</th>
                    <td>{fmtNumber(fichaData.producto?.potenciaKw)}</td>

                    <th>Tensión Volt</th>
                    <td>{fmtNumber(fichaData.producto?.tensionVolt)}</td>
                  </tr>

                  <tr>
                    <th>Capacidad Ah</th>
                    <td>{fmtNumber(fichaData.producto?.capacidadAh)}</td>

                    <th>Capacidad Kwh</th>
                    <td>{fmtNumber(fichaData.producto?.capacidadKwh)}</td>
                  </tr>

                  <tr>
                    <th>Cant. Paneles</th>
                    <td>{fmtNumber(fichaData.producto?.cantidadPaneles)}</td>

                    <th>Pot. Panel Watts</th>
                    <td>
                      {fmtNumber(fichaData.producto?.potenciaPanelWatts)}
                    </td>
                  </tr>

                  <tr>
                    <th>Precio Venta USD</th>
                    <td>{formatUSD(fichaData.producto?.precioVentaUSD)}</td>

                    <th>Precio Mínimo USD</th>
                    <td>{formatUSD(fichaData.producto?.precioMinimoUSD)}</td>
                  </tr>

                  <tr>
                    <th>Comisión Base USD</th>
                    <td>{formatUSD(fichaData.producto?.comisionBaseUSD)}</td>

                    <th>Costo Envío USD</th>
                    <td>{formatUSD(fichaData.producto?.costoEnvioUSD)}</td>
                  </tr>

                  <tr>
                    <th>Política Envío</th>
                    <td>{textOrDash(fichaData.producto?.politicaEnvio)}</td>

                    <th>Permite Envío</th>
                    <td>{fichaData.producto?.permiteEnvio ? "Sí" : "No"}</td>
                  </tr>

                  <tr>
                    <th>Demora Entrega</th>
                    <td>{textOrDash(fichaData.producto?.demoraEntrega)}</td>

                    <th>Aclaración</th>
                    <td>{textOrDash(fichaData.producto?.aclaracion)}</td>
                  </tr>

                  <tr>
                    <th>Observaciones</th>
                    <td colSpan={3}>
                      {textOrDash(fichaData.producto?.observaciones)}
                    </td>
                  </tr>
                </tbody>
              </BsTable>

              {Array.isArray(fichaData.producto?.especificaciones) &&
                fichaData.producto.especificaciones.length > 0 && (
                  <>
                    <h6 className="mt-3">Especificaciones</h6>

                    <BsTable bordered size="sm" responsive style={{ fontSize: 13 }}>
                      <thead>
                        <tr>
                          <th>Especificación</th>
                          <th>Valor</th>
                        </tr>
                      </thead>

                      <tbody>
                        {fichaData.producto.especificaciones.map((e, idx) => (
                          <tr key={`${e?.nombre}-${idx}`}>
                            <td>{textOrDash(e?.nombre)}</td>
                            <td>{textOrDash(e?.valor)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </BsTable>
                  </>
                )}
            </>
          ) : (
            <div className="text-muted">Sin datos para mostrar.</div>
          )}
        </Modal.Body>

        {/* <Modal.Footer>
          {fichaData?.producto && (
            <Button
              variant="danger"
              onClick={() => generarPdfFicha(fichaData.producto)}
              disabled={pdfLoadingId === fichaData.producto?._id}
            >
              PDF
            </Button>
          )}

          <Button variant="secondary" onClick={() => setShowFicha(false)}>
            Cerrar
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
}